export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export const AUTH_API_ENDPOINT = process.env.REACT_APP_AUTH_API_ENDPOINT;
export const AUTH_API_CLIENT_ID = process.env.REACT_APP_AUTH_API_CLIENT_ID;
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

export const ACCEPTED_IMAGE_FORMAT = 'image/jpg,image/jpeg,image/png';
export const DEFAULT_OPENING_TIMINGS = 'To be populated by Admin';
